import React from 'react';

export const EvolveLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='227'
    height='57'
    viewBox='0 0 227 57'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_29_1098)'>
      <path
        d='M219.458 19.6742C215.227 19.6742 211.916 22.9839 211.916 27.2129C211.916 31.4419 215.227 34.7516 219.458 34.7516C223.689 34.7516 227 31.4419 227 27.2129C227 22.9839 223.505 19.6742 219.458 19.6742ZM217.619 26.1097C216.883 26.1097 216.331 26.6613 216.331 27.3968V29.6032V29.7871H215.043V24.8226H216.331V25.0065C216.699 24.8226 217.067 24.6387 217.619 24.6387V26.1097ZM224.057 27.3968V29.971H222.769V27.3968C222.769 26.6613 222.217 26.1097 221.482 26.1097C220.746 26.1097 220.194 26.6613 220.194 27.3968V29.971H218.906V22.2484H220.194V25.3742C220.562 25.1903 220.93 25.0065 221.482 25.0065C222.953 24.8226 224.057 26.1097 224.057 27.3968Z'
        fill='#00C4B3'
      />
      <path
        d='M91.2415 29.0516C96.3923 29.0516 100.623 33.2806 100.623 38.429C100.623 43.5774 96.3923 47.8065 91.2415 47.8065C86.0908 47.8065 81.8598 43.5774 81.8598 38.429C81.8598 33.0968 86.0908 29.0516 91.2415 29.0516ZM91.2415 19.6742C80.9401 19.6742 72.6621 27.9484 72.6621 38.2452C72.6621 48.5419 80.9401 57 91.2415 57C101.543 57 109.821 48.7258 109.821 38.429C109.821 27.9484 101.543 19.6742 91.2415 19.6742Z'
        fill='#00416B'
      />
      <path
        d='M59.6016 56.2645H50.22L37.1592 20.2258H47.2767L55.0028 43.0258L62.5449 20.2258H72.6624L59.6016 56.2645Z'
        fill='#00416B'
      />
      <path
        d='M154.338 56.2645H144.956L131.896 20.2258H142.013L149.739 43.0258L157.281 20.2258H167.399L154.338 56.2645Z'
        fill='#00416B'
      />
      <path
        d='M37.3428 41.7387V38.429V38.2452V38.0613V37.8774C37.1588 27.7645 28.8809 19.6742 18.7634 19.6742C8.27796 19.6742 0 27.9484 0 38.2452C0 48.5419 8.27796 57 18.5794 57C24.0981 57 28.8809 54.6097 32.376 50.9323L25.7536 44.3129C24.0981 46.3355 21.5227 47.6226 18.5794 47.6226C14.7164 47.6226 11.2212 45.2323 9.93355 41.7387H37.3428ZM18.5794 29.0516C22.4425 29.0516 25.7536 31.4419 27.2253 34.9355H10.1175C11.4052 31.4419 14.7164 29.0516 18.5794 29.0516Z'
        fill='#00416B'
      />
      <path
        d='M204.925 41.7387V38.429V38.2452V38.0613V37.8774C204.741 27.7645 196.464 19.6742 186.346 19.6742C176.045 19.6742 167.767 27.9484 167.767 38.2452C167.767 48.5419 176.045 56.8161 186.346 56.8161C191.865 56.8161 196.647 54.4258 200.143 50.7484L193.52 44.129C191.865 46.1516 189.289 47.4387 186.346 47.4387C182.483 47.4387 178.988 45.0484 177.7 41.5548L204.925 41.7387ZM186.346 29.0516C190.209 29.0516 193.52 31.4419 194.992 34.9355H177.7C179.172 31.4419 182.483 29.0516 186.346 29.0516Z'
        fill='#00416B'
      />
      <path
        d='M123.25 38.429V0H113.868V38.0613V38.2452V38.429C114.052 48.3581 121.962 56.4484 131.896 56.6323V47.2548C127.113 47.2548 123.25 43.3935 123.25 38.429Z'
        fill='#00416B'
      />
    </g>
    <defs>
      <clipPath id='clip0_29_1098'>
        <rect width='227' height='57' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
